"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _classnames3 = _interopRequireDefault(require("classnames"));
var _modalProvider = require("../modal-provider");
var _theme = require("../theme");
var _legacyOverlay = _interopRequireDefault(require("./legacy-overlay"));
var _closeButton = _interopRequireDefault(require("./close-button"));
var _image = _interopRequireDefault(require("./image"));
require("./overlay.css");
var _excluded = ["useLegacyOverlay"],
  _excluded2 = ["contentStyle", "className"];
/* eslint-disable complexity */
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
/**
 * Creates a fixed position overlay to be used in conjunction with ModalProvider.
 * Overlay does not create a mask or manage focus; to get an accessible modal overlay with
 * a mask see <a href='/components/modals'>ModalProvider</a> documentation.
 *
 * In mobile viewports, the overlay covers the entire viewport. In desktop, user
 * can choose from a variety of presets for what portion of the viewport will cover.
 * See prop options below.
 *
 * The overlay comes with an optional close button which will automatically close the
 * modal when used in conjunction with the ModalProvider component.
 *
 * In your Overlay's content, please include a heading for accessibility; the heading level
 * should be an h2 (as it is expected that you have an h1 on the page already).
 */
// eslint-disable-next-line max-statements
var Overlay = function Overlay(_ref) {
  var _ref$useLegacyOverlay = _ref.useLegacyOverlay,
    useLegacyOverlay = _ref$useLegacyOverlay === void 0 ? false : _ref$useLegacyOverlay,
    props = _objectWithoutProperties(_ref, _excluded);
  if (useLegacyOverlay) {
    return /*#__PURE__*/_react["default"].createElement(_legacyOverlay["default"], props);
  }
  var _props$alignment = props.alignment,
    alignment = _props$alignment === void 0 ? 'rightCrate' : _props$alignment;
  var children = props.children,
    childrenContainerClassName = props.childrenContainerClassName,
    className = props.className,
    _props$closeCallback = props.closeCallback,
    closeCallback = _props$closeCallback === void 0 ? function () {} : _props$closeCallback,
    _props$closeProps = props.closeProps,
    closeProps = _props$closeProps === void 0 ? {} : _props$closeProps,
    containerProps = props.containerProps,
    _props$contentProps = props.contentProps,
    contentProps = _props$contentProps === void 0 ? {} : _props$contentProps,
    _props$imageAlt = props.imageAlt,
    imageAlt = _props$imageAlt === void 0 ? '' : _props$imageAlt,
    imageContainerProps = props.imageContainerProps,
    _props$imageObjectFit = props.imageObjectFit,
    imageObjectFit = _props$imageObjectFit === void 0 ? 'cover' : _props$imageObjectFit,
    imagePath = props.imagePath,
    permitImageToShrink = props.permitImageToShrink,
    _props$renderCloseBut = props.renderCloseButton,
    renderCloseButton = _props$renderCloseBut === void 0 ? true : _props$renderCloseBut,
    style = props.style,
    _props$topShadow = props.topShadow,
    topShadow = _props$topShadow === void 0 ? false : _props$topShadow;
  var contentStyle = contentProps.contentStyle,
    contentClassName = contentProps.className,
    otherContentProps = _objectWithoutProperties(contentProps, _excluded2);
  var _ref2 = (0, _react.useContext)(_modalProvider.ModalContext) || {},
    _ref2$closeModal = _ref2.closeModal,
    closeModal = _ref2$closeModal === void 0 ? function () {} : _ref2$closeModal;
  var theme = (0, _react.useContext)(_theme.ThemeContext);
  var isImageVariant = Boolean(imagePath);
  if (isImageVariant) {
    // Image variant is intended to be displayed in the dialog variant.
    // Override if user has set to anything besides 'dialog' for alignment.
    alignment = 'dialog';
  }
  var isDialogVariant = alignment.includes('dialog');
  var isDarkTheme = theme === _theme.themes.dark;
  var themeClass = isDarkTheme ? 'bg-houseGreen color-textWhite' : 'bg-white';
  var containerClasses = (0, _classnames3["default"])(className, 'sb-overlay__container', _defineProperty({
    'sb-overlay--dialog flex justify-center items-center': isDialogVariant,
    'sb-overlay--leftCrate': alignment === 'leftCrate',
    'sb-overlay--rightCrate': alignment === 'rightCrate',
    'sb-overlay--leftThird': alignment === 'leftThird',
    'sb-overlay--rightThird': alignment === 'rightThird',
    'sb-overlay--topShadow': topShadow
  }, themeClass, !isDialogVariant));
  var contentClasses = (0, _classnames3["default"])('flex flex-column', contentClassName, _defineProperty({
    'sb-overlay--heightLimit': permitImageToShrink,
    'sb-overlay--dialog__content relative': isDialogVariant,
    'sb-overlay--dialog__contentLg': alignment === 'dialog-lg'
  }, themeClass, isDialogVariant));
  var combinedContentStyle = _objectSpread(_objectSpread({}, contentStyle), permitImageToShrink ? {
    maxHeight: 'fit-content'
  } : {});
  return /*#__PURE__*/_react["default"].createElement("div", _extends({
    className: containerClasses,
    key: "container",
    style: style
  }, containerProps), /*#__PURE__*/_react["default"].createElement("div", _extends({
    className: contentClasses,
    key: "content",
    style: combinedContentStyle
  }, otherContentProps), renderCloseButton && /*#__PURE__*/_react["default"].createElement(_closeButton["default"], {
    closeCallback: closeCallback,
    closeModal: closeModal,
    closeProps: closeProps,
    isDarkTheme: isDarkTheme,
    isDialogVariant: isDialogVariant,
    isImageVariant: isImageVariant
  }), isImageVariant && /*#__PURE__*/_react["default"].createElement(_image["default"], {
    alt: imageAlt,
    containerProps: imageContainerProps,
    objectFit: imageObjectFit,
    permitToShrink: permitImageToShrink,
    src: imagePath
  }), /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _classnames3["default"])('flex-grow', childrenContainerClassName, {
      'flex-shrink-none': permitImageToShrink
    })
  }, children)));
};
Overlay.propTypes = process.env.NODE_ENV !== "production" ? {
  /**
   * Indicates what portion of the UI is covered in desktop viewports.
   */
  alignment: _propTypes["default"].oneOf(['dialog', 'dialog-lg', 'fullscreen', 'rightCrate', 'leftCrate', 'rightThird', 'leftThird']),
  /**
   * Nested component(s) which become the content of the overlay.
   */
  children: _propTypes["default"].any,
  /**
   * Classname passed to the element that wraps the children
   */
  childrenContainerClassName: _propTypes["default"].string,
  /**
   * Optional function to run when the overlay is closing.
   */
  closeCallback: _propTypes["default"].func,
  /**
   * Props passed to the CloseButton component within the Overlay.
   */
  closeProps: _propTypes["default"].object,
  /**
   * Additional props to be spread on the container HTMLElement.
   */
  containerProps: _propTypes["default"].object,
  /**
   * Additional props to be spread on the content HTMLElement.
   */
  contentProps: _propTypes["default"].object,
  /**
   * Prop to allow for giving alternate text to the image
   */
  imageAlt: _propTypes["default"].string,
  /**
   * Props to pass into the container around the image
   */
  imageContainerProps: _propTypes["default"].object,
  /**
   * Optional prop to allow for image to be placed on top of the Overlay.
   */
  imagePath: _propTypes["default"].string,
  /**
   * Optional prop to allow for a top-image to be responsive. This is useful when you have tall content and a scalable image. Only applicable if imagePath is passed.
   */
  permitImageToShrink: _propTypes["default"].bool,
  /**
   * Optional prop to control the object-fit of the top image. Only applicable if imagePath is passed and permitImageToShrink is true.
   */
  imageObjectFit: _propTypes["default"].oneOf(['cover', 'contain', 'fill', 'scale-down']),
  /**
   * Whether to use the included default CloseButton component. If false, consumer is expected to
   * provide a custom close button in the child component.
   */
  renderCloseButton: _propTypes["default"].bool,
  /**
   * Optional style object for custom styling such as z-index; applied to the outermost div.
   */
  style: _propTypes["default"].object,
  /**
   * A CSS box shadow intended for situations in which another container is visually 'above' the
   * overlay.
   */
  topShadow: _propTypes["default"].bool
} : {};
var _default = exports["default"] = Overlay;